// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"af7fba98","186":"2100c2f7","215":"b6287130","334":"37f38bc1","372":"cbe2b31d","377":"ef771ac2","630":"06491584","738":"e5f0728c","815":"48d2852b","841":"7038fdf3","851":"89356949","856":"d265f8c1"}[chunkId] + ".chunk.js";
};